import { useState, useEffect } from "react";
import ReactTimeago from "../_Shared/Timeago";
import {
  Paper,
  Group,
  Container,
  Text,
  Grid,
  Avatar,
  Center,
  Loader,
  Button,
} from "@mantine/core";
import { deleteUser, getSingleUser, resetUserPasskeys } from "../api";
import { notifications } from "@mantine/notifications";
import { Link, useLocation } from "wouter";
import { useTranslation } from "react-i18next";

export default function UserDetails({ params }) {
  const { t } = useTranslation("Users");
  const [, setLocation] = useLocation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    getSingleUser(params.id).then((data) => {
      setUser(data);
    });
  }, []);

  if (!user)
    return (
      <Center mt="xl">
        <Loader size="xl" />
      </Center>
    );

  return (
    <Container px={0}>
      <Grid justify="space-between" gap="2px">
        <Grid.Col span={12}>
          <Button component={Link} to={`/users/edit/${params.id}`} mr="md">
            {t("edit", "Edit")}
          </Button>
          <Button
            mr="md"
            variant="outline"
            onClick={async () => {
              if (
                !window.confirm(
                  t(
                    "reset_passkeys_confirm",
                    "Reset this user's passkeys? They will sign in with their password and be prompted to create a new passkey. Use this to recover a lost or stolen device.",
                  ),
                )
              )
                return;
              try {
                await resetUserPasskeys(params.id);
                notifications.show({
                  color: "teal",
                  title: t("reset_passkeys_done_title", "Passkeys reset"),
                  message: t(
                    "reset_passkeys_done_msg",
                    "The user can now sign in with their password and enroll a new passkey.",
                  ),
                });
              } catch (e) {
                notifications.show({
                  color: "red",
                  title: t("reset_passkeys_error_title", "Couldn't reset passkeys"),
                  message: e.message,
                });
              }
            }}
          >
            {t("reset_passkeys", "Reset passkeys")}
          </Button>
          <Button
            onClick={async () => {
              await deleteUser(params.id);
              setLocation("/users");
            }}
            color="red"
            variant="outline"
          >
            {t("delete", "Delete")}
          </Button>
        </Grid.Col>
        <Grid.Col span={3}>
          <Text mb="sm" fw={500}>
            {t("versions", "Versions")}
          </Text>
          {/* TBD Version History */}
          <Paper p="xs" mb="xs">
            <Group>
              <Avatar>JD</Avatar> John Doe
            </Group>
            <Text ta="right" c="dimmed">
              <ReactTimeago date={prompt.created} />
            </Text>
          </Paper>
        </Grid.Col>

        <Grid.Col span={9}>
          <Text mb="sm" fw={500}>
            {t("details", "Details")}
          </Text>
        </Grid.Col>
      </Grid>
    </Container>
  );
}
